import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { PapiUser } from '@wix/da-papi-types';

import EmptyState from '../../../../EmptyState';
import PremiumFolderCreateButton from '../PremiumFolderCreateButton';

import s from './PremiumFoldersEmptyState.scss';

export interface Props {
  view: 'wide' | 'large';
  user: PapiUser;
  isOwner: boolean;
  onOpenChat: (user: PapiUser) => void;
}

export const PremiumFoldersEmptyState: React.FC<Props> = ({
  view,
  user,
  user: { username },
  isOwner,
  onOpenChat,
}) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);

  const { title, subtitle } = getText({
    t,
    username,
    isOwner,
    isMobile,
  });

  const handleOpenChat = () => onOpenChat(user);

  return (
    <EmptyState
      className={classnames(s['root'], s[view])}
      title={title}
      subtitle={subtitle}
      subtitleClassName={s['subtitle']}
      withButton={!isOwner}
      onButtonClick={handleOpenChat}
      buttonLabel={t('pages.shop.emptyState.openChatWithArtist')}
      customButton={
        isOwner &&
        !isMobile && (
          <PremiumFolderCreateButton
            label={t('pages.shop.emptyState.addNewPremiumFolder')}
          />
        )
      }
    />
  );
};

function getText({
  t,
  username,
  isOwner,
  isMobile,
}: {
  t;
  username: string;
  isOwner: boolean;
  isMobile: boolean;
}) {
  if (!isOwner) {
    return {
      title: t('pages.shop.emptyState.premiumFolders.title.visitor', {
        username,
      }),
      subtitle: t('pages.shop.emptyState.premiumFolders.subtitle.visitor'),
    };
  }

  if (isMobile) {
    return {
      title: t('pages.shop.emptyState.premiumFolders.title.owner.mobile'),
      subtitle: t('pages.shop.emptyState.premiumFolders.subtitle.owner.mobile'),
    };
  }

  return {
    title: t('pages.shop.emptyState.premiumFolders.title.owner'),
    subtitle: t('pages.shop.emptyState.premiumFolders.subtitle.owner'),
  };
}

PremiumFoldersEmptyState.displayName = 'PremiumFoldersEmptyState';

export default PremiumFoldersEmptyState;
